import React, { useState } from 'react';

function SurveyStepThirtyThree({ formData, onNext }) {
    const [changeSuggestionRating, setChangeSuggestionRating] = useState(formData.changeSuggestionRating || '');
    const [changeSuggestionComments, setChangeSuggestionComments] = useState(formData.changeSuggestionComments || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!changeSuggestionRating) {
            setError('Please select a rating.');
            return;
        }
        setError('');
        onNext({ changeSuggestionRating, changeSuggestionComments });
    };

    const ratingOptions = ['N/A', ...Array.from({ length: 10 }, (_, i) => (i + 1).toString())];

    return (
        <div className="step-form">
            <h6 className="mb-4">Section 7: Leadership & Management</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <label className="form-label">
                What would you like to see leadership and management do differently, and why? <span className="text-danger">*</span>
            </label>

            <div className="d-flex flex-wrap gap-2 mb-4 justify-content-around">
                {ratingOptions.map((option) => (
                    <div key={option} className="form-check rating_btn">
                        <input
                            type="radio"
                            id={`change-suggestion-rating-${option}`}
                            name="changeSuggestionRating"
                            value={option}
                            checked={changeSuggestionRating === option}
                            onChange={() => setChangeSuggestionRating(option)}
                        />
                        <label htmlFor={`change-suggestion-rating-${option}`}>{option}</label>
                    </div>
                ))}
            </div>

            <div className="mb-3">
                <label className="form-label">Additional comments (optional):</label>
                <textarea
                    className="form-control"
                    rows="4"
                    value={changeSuggestionComments}
                    onChange={(e) => setChangeSuggestionComments(e.target.value)}
                    placeholder="Share any additional thoughts here..."
                />
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!changeSuggestionRating}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default SurveyStepThirtyThree;
